export default "__VITE_ASSET__r9xjTZWH__"